// extracted by mini-css-extract-plugin
module.exports = {"congrats-box":"congrats-box___1kAIN","label-block":"label-block___3BzZH","label":"label___1M8Z9"};